// Vue
import Vue from 'vue'
import Vuex from 'vuex'
// firebase initialised
import db from '@/firebase/init'
import pathify from '@/plugins/vuex-pathify'
import VuexPersistence from 'vuex-persist'
import VueSocialSharing from 'vue-social-sharing'

// Modules
import * as modules from './modules'

Vue.use(Vuex)
// import firebase initialised
Vue.use(db)
Vue.use(VueSocialSharing)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
})

const store = new Vuex.Store({
  modules,
  plugins: [
    pathify.plugin,
    vuexLocal.plugin,
  ],
})

store.subscribe(mutation => {
  if (!mutation.type.startsWith('user/')) return

  store.dispatch('user/update', mutation)
})

store.dispatch('app/init')

export default store

export const ROOT_DISPATCH = Object.freeze({ root: true })
